import React from "react";

export default function useQuery() {
	return React.useMemo(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		return Object.fromEntries(urlSearchParams.entries());
	}, [window.location.search]);
}
